import { CardFormat } from '../../../ProductDetailsPage/constants';

export type FormatDisplayParam = CardFormat.paper | CardFormat.premiumDigital | 'all';

/** Feature options that imply a tile-price display format. */
const PAPER_CODES: ReadonlySet<string> = new Set(['format:paper']);
const DIGITAL_CODES: ReadonlySet<string> = new Set(['format:digital', 'price:basic']);

export const isFormatFacetOption = (compositeCode: string) => PAPER_CODES.has(compositeCode) || DIGITAL_CODES.has(compositeCode);

/**
 * The `?format=` tile-price display setting implied by the selection: "Digital" / "Free"
 * show digital prices (a URL-only `format:paper` shows paper prices; both show both), and
 * nothing format-related selected clears the override. Mirrors what the nav's deep links
 * set alongside their `pf` facet. Pure.
 */
export const deriveFormatDisplayParam = (activeFilters: ReadonlySet<string>): FormatDisplayParam | null => {
  let paper = false;
  let digital = false;
  for (const code of activeFilters) {
    if (PAPER_CODES.has(code)) paper = true;
    if (DIGITAL_CODES.has(code)) digital = true;
  }
  if (paper && digital) return 'all';
  if (paper) return CardFormat.paper;
  if (digital) return CardFormat.premiumDigital;
  return null;
};
